export enum SOCKET_PRODUCT_EVENT {
  /**
   * Event fired when a product has been created
   */
  created = 'product:created',

  /**
   * Event fired when a product has been activated or deactivated
   */
  activated = 'product:activated',

  /**
   * Event fired when a product has been modified
   */
  modified = 'product:modified',

  /**
   * Event fired when a product has been modified from their folders
   */
  foldersModified = 'product:folders_modified',
}
